/* Flor de Oro — cart display cleanup
   Keeps customer-facing cart clean after cart drawer AJAX refreshes. */
(function(){
  'use strict';
  if(window.FDOCartCleanupReady) return;
  window.FDOCartCleanupReady = true;

  var hiddenLabels = [
    'Number of Engravings',
    'Customizer type',
    'Selected cat art',
    'Creation side',
    'Pet product type',
    'Creation style',
    'Writing style',
    'Engraving service',
    'Saved occasion selected',
    'Saved occasion budget'
  ];

  function normalizeLabel(text){
    return String(text || '')
      .replace(/:/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function shouldHide(label){
    if(!label) return false;
    if(label.charAt(0) === '_') return true;
    if(/^FDO\b/i.test(label)) return true;
    if(/^_FDO\b/i.test(label)) return true;
    return hiddenLabels.indexOf(label) !== -1;
  }

  function cleanCartProperties(root){
    root = root || document;

    Array.prototype.slice.call(root.querySelectorAll('.product-option')).forEach(function(row){
      var dt = row.querySelector('dt');
      if(!dt) return;
      var label = normalizeLabel(dt.textContent);
      if(shouldHide(label)){
        row.style.display = 'none';
        row.setAttribute('aria-hidden', 'true');
      }
    });

    Array.prototype.slice.call(root.querySelectorAll('dl')).forEach(function(dl){
      var visibleRows = Array.prototype.slice.call(dl.children).filter(function(child){
        return child.style.display !== 'none';
      });
      if(!visibleRows.length){
        dl.style.display = 'none';
        dl.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function scheduleClean(root){
    window.requestAnimationFrame(function(){ cleanCartProperties(root || document); });
  }

  function init(){ scheduleClean(document); }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('cart:updated', function(){ scheduleClean(document); });
  document.addEventListener('shopify:section:load', function(event){ scheduleClean(event.target || document); });

  if(window.PUB_SUB_EVENTS && window.subscribe && window.PUB_SUB_EVENTS.cartUpdate){
    try {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function(){ scheduleClean(document); });
    } catch(error) {
      console.warn('[FDO] Cart cleanup pubsub subscription skipped:', error);
    }
  }

  var observer = new MutationObserver(function(mutations){
    var needsClean = mutations.some(function(mutation){
      return Array.prototype.slice.call(mutation.addedNodes || []).some(function(node){
        return node && node.nodeType === 1 && (
          node.matches && (node.matches('.product-option, cart-drawer, cart-items, cart-drawer-items') || node.querySelector('.product-option'))
        );
      });
    });
    if(needsClean) scheduleClean(document);
  });

  if(document.body){
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function(){
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
})();